import type { ExtractionStatus } from '@vrzl/database';
import { VTooltip, VTooltipContent, VTooltipTrigger } from '@vrzl/ui';
import type { ReactNode } from 'react';

import { extractionStatusDescriptions, extractionStatusLabels } from '../constants';

type ExtractionStatusTooltipProps = {
  status: ExtractionStatus;
  error?: string | null;
  children: ReactNode;
};

/**
 * Hover tooltip rond een extractiestatus-icoon: een korte uitleg per status,
 * plus de foutmelding (Case.extractionError) wanneer de extractie mislukt is.
 */
export function ExtractionStatusTooltip({
  status,
  error,
  children,
}: ExtractionStatusTooltipProps) {
  const showError = status === 'FAILED' && error != null;

  return (
    <VTooltip>
      <VTooltipTrigger asChild>
        <span className="inline-flex items-center cursor-help">{children}</span>
      </VTooltipTrigger>
      <VTooltipContent className="max-w-sm">
        <div className="font-medium">{extractionStatusLabels[status]}</div>
        <div className="mt-1 text-muted-foreground">
          {extractionStatusDescriptions[status]}
        </div>
        {showError && (
          <pre className="mt-2 max-h-48 overflow-auto whitespace-pre-wrap text-xs">
            {error}
          </pre>
        )}
      </VTooltipContent>
    </VTooltip>
  );
}
